export const UPDATE_MERCHANT_APPLICATION_STATUS = gql`
    mutation UpdateMerchantApplicationStatus(
        $status: ApplicationStatus
        $applicationId: Int
        $merchantId: Int
    ) {
        updateMerchantApplicationStatus(
            status: $status
            applicationId: $applicationId
            merchantId: $merchantId
        ) {
            id
        }
    }
`;
